import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import moment from "moment";
import { CANCELBOOKINGDETAIL } from "../../../../../services/ApiCalls";
import { catchAsync } from "../../../../../utilities/utilities";
import Loader from "../../../../../components/Common/Loader";

const CancelOrderDetail = () => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [cancelBooking, setCancelBooking] = useState(null);

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await CANCELBOOKINGDETAIL(id);
    if (res.status === 200 && res.data) {
      setCancelBooking(res.data.data?.cancelBooking);
    }
    setLoader(false);
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  if (loader) return <Loader />;

  const customer = cancelBooking?.customerId || {};
  const booking = cancelBooking?.bookingId || {};
  const hotel = booking?.hotelId || {};

  return (
    <section className="detail position-relative py-3">
      <Container>
        <Row>
          <Col lg="12">
            <div className="d-flex align-items-center gap-10">
              <Button
                onClick={() => navigate(-1)}
                className="border d-flex align-items-center p-2 rounded"
              ></Button>
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                {t("bookingUpcoming.view.title")}
              </h4>
            </div>
          </Col>

          {/* User Detail */}
          <Col lg="6" className="my-2">
            <label
              style={{ fontSize: "1.3rem", fontWeight: "bold" }}
              className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
            >
              {t("bookingUpcoming.view.userDetail")}
            </label>

            <div className="cardCstm px-lg-4 px-3 py-2 rounded" style={{ background: "#eee" }}>
              <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.name")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {customer.first_name} {customer.last_name}
                  </p>
                </li>

                <li className="py-2 d-flex align-items-start">  
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.email")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">{customer.email || ""}</p>
                </li>

                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.phone")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {customer.mobileNumber || ""}
                  </p>
                </li>

                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.country")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {customer.country || ""}
                  </p>
                </li>
              </ul>
            </div>
          </Col>

          {/* Hotel Detail */}
          <Col lg="6" className="my-2">
            <label
              style={{ fontSize: "1.3rem", fontWeight: "bold" }}
              className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
            >
              {t("bookingUpcoming.view.hotelDetail")}
            </label>

            <div className="cardCstm px-lg-4 px-3 py-2 rounded" style={{ background: "#eee" }}>
              <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.hotelName")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {hotel.hotelName || ""}
                  </p>
                </li>

                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.hotelId")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {hotel.hotelId || ""}
                  </p>
                </li>

                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.email")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {hotel.email || ""}
                  </p>
                </li>

                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.phone")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {hotel.mobileNumber || ""}
                  </p>
                </li>

                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.address")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {hotel.address || ""}
                  </p>
                </li>
              </ul>
            </div>
          </Col>
          <Col lg="6" className="my-2">
            <label
              style={{ fontSize: "1.3rem", fontWeight: "bold" }}
              className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
            >
              {t("bookingUpcoming.view.bookingDetail")}
            </label>
            <div
              className="cardCstm px-lg-4 px-3 py-2 rounded"
              style={{ background: "#eee" }}
            >
              <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.bookingId")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {booking.bookingId || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.cost")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {booking.currencySymbol} {booking.finalPrice || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.stayNights")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {booking.nightCount || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.numberOfGuest")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {booking.numberOfGuests || ""}
                  </p>
                </li>

                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25"> {t("bookingUpcoming.view.bookingStatus")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75 text-capitalize">
                    {bookingDetails?.bookingStatus || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.checkIn")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {booking.startDate
                      ? moment(booking.startDate).format("MM-DD-YYYY , HH:mm")
                      : ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.view.checkOut")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {booking.endDate
                      ? moment(booking.endDate).format("MM-DD-YYYY , HH:mm")
                      : ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.tabel.reason")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {booking?.reason || "-"}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">{t("bookingUpcoming.cancel.refundStatus")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75 text-capitalize">
                    {booking?.refundStatus || "-"}
                  </p>
                </li>
              </ul>
            </div>
          </Col>

          <Col lg="6" className="my-2">
            <label
              style={{ fontSize: "1.3rem", fontWeight: "bold" }}
              className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
            >
              {t("bookingUpcoming.view.paymentDetail")}
            </label>
            <div
              className="cardCstm px-lg-4 px-3 py-2 rounded"
              style={{ background: "#eee" }}
            >
              <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-50">{t("bookingUpcoming.view.paymentStatus")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75 text-capitalize">
                    {booking.paymentStatus || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-50">{t("bookingUpcoming.view.serviceFee")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {/* Not present in response, maybe 0 or - */}-
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-50">{t("bookingUpcoming.view.tax")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {booking.taxes ? `$${booking.taxes}` : "-"}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-50">{t("bookingUpcoming.view.totalAmount")}:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {booking.currencySymbol} {booking.finalPrice || ""}

                  </p>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CancelOrderDetail;
